import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  TemplateRef,
  NgZone,
  Inject,
} from '@angular/core'
import { I18NService } from '@core'
import { ChartEChartsComponent, ChartEChartsOption } from '@delon/chart/chart-echarts'
import { _HttpClient, ALAIN_I18N_TOKEN } from '@delon/theme'
import { round } from '@delon/util/math'
import { environment } from '@env/environment'
import { NzMessageService } from 'ng-zorro-antd/message'
import { NzModalService } from 'ng-zorro-antd/modal'
import { of, take, toArray } from 'rxjs'
const { msUrl } = environment.api

import files from '../support/guid/files.json'
import questions from '../support/question/questions.json'

const methodDecorator = (message: string) => {
  return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
    const originalMethod = descriptor.value

    descriptor.value = function (...args: any[]) {
      // target.newMethod()
      // console.log(target)
      // console.log(`方法 ${propertyKey} 被调用了，附加消息: ${message}`)
      const result = originalMethod.apply(this, args)
      // console.log(`方法 ${propertyKey} 执行结果为: ${JSON.stringify(result)}`)
      return result
    }

    return descriptor
  }
}

const classDecorator = <T extends { new (...args: any[]): {} }>(constructor: T) => {
  constructor.prototype.age = 18
  constructor.prototype.newMethod = () => {
    console.log('This is a new method.')
  }
}

@classDecorator
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class DashboardComponent implements OnInit, AfterViewInit {
  yearData: any = []
  yearStatistics: any = {} as any
  selectedYear: any = ''
  unitList: any = []
  unitStatistics: any = {}
  selectedUnit: string = ''
  selectedUnitName: string = ''
  option: ChartEChartsOption = {}
  option2: ChartEChartsOption = {}
  option3: ChartEChartsOption = {}
  guids: any = []
  questionsDataList: any = []
  title2: string = ''
  answer: string = ''
  message = 'Hello World'
  sangjiHeight = '800px'
  // i = 1
  // num = 0
  apiKey = '17cjlprl889m955viuqo3xjt07r98so21oxbpml3m79vz126'
  config = {
    plugins: 'lists link image table code help wordcount',
    images_upload_url: '/demo/upimg.php',
    images_upload_base_path: '/demo',
    language: 'zh_CN',
  }

  @ViewChild('chart1') chart1!: ChartEChartsComponent
  @ViewChild('chart2') chart2!: ChartEChartsComponent
  @ViewChild('chart3') chart3!: ChartEChartsComponent
  constructor(
    private msg: NzMessageService,
    private cd: ChangeDetectorRef,
    private http: _HttpClient,
    private modal: NzModalService,
    // private ngZone: NgZone,
    @Inject(ALAIN_I18N_TOKEN) private i18n: I18NService,
  ) {}

  ngOnInit(): void {
    this.initYear()
    this.initGuids()
    this.initQuestions()

    // this.ngZone.runOutsideAngular(() => {
    //   let i = 0
    //   const token = setInterval(() => {
    //     this.ngZone.run(() => {
    //       this.num = ++i
    //     })

    //     if (i == 10) {
    //       clearInterval(token)
    //     }
    //   }, 1000)
    // })
  }

  ngAfterViewInit(): void {
    this.chart1.chart?.resize()
    this.chart2.chart?.resize()
    this.chart3.chart?.resize()
  }

  initGuids(): void {
    this.guids = of(
      ...files.map((item: any) => ({
        ...item,
        url: `../../../../assets/guid/${item.name}pdf`,
      })),
    ).pipe(take(8), toArray())
  }

  @methodDecorator('Custom Message')
  initQuestions(): void {
    this.questionsDataList = of(
      ...questions.map((item: any) => ({
        ...item,
      })),
    ).pipe(take(8), toArray())
  }

  createTplModal(
    tplTitle: TemplateRef<{}>,
    tplContent: TemplateRef<{}>,
    tplFooter: TemplateRef<{}>,
    title: any,
  ): void {
    this.title2 = title
    this.answer = questions.find((item: any) => item.title == title).answer
    this.modal.create({
      nzWidth: 600,
      nzTitle: tplTitle,
      nzContent: tplContent,
      nzFooter: tplFooter,
      nzMaskClosable: false,
      nzClosable: false,
      nzOnOk: () => console.log('Click ok'),
    })
  }

  initYear(): void {
    const yearStr = this.i18n.fanyi('app.dashboard.year')
    this.http.get(`${msUrl.core}/dashboard/yearList`, { orderBy: 'asc' }).subscribe((res) => {
      const { data } = res
      this.yearData = [
        ...data
          .sort()
          .reverse()
          .map((val: any) => ({
            name: `${val}${yearStr}`,
            val,
          })),
      ]
      const year = data?.[0]
      if (year) {
        this.selectedYear = year
        this.initChartData(year)
        this.initYearData(year)
        this.initUnits(year)
        this.initChart3Data(year)
      }

      // setTimeout(()=>{
      //   this.cd.markForCheck()
      // },1000)
    })
  }

  initChartData(year: any): void {
    this.http.get(`${msUrl.core}/dashboard/${year}/unitChart`).subscribe((res) => {
      const { data } = res
      const { x, y } = data
      const names = [] as any

      y.forEach((item: any) => {
        names.push(item.name)
      })

      this.option = {
        title: {
          text: this.i18n.fanyi('app.dashboard.overview.emissions-per-unit'),
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          show: false,
          // itemHeight:10,
          // itemWidth:20,
          data: [...names],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            //saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [...x],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          ...y.map((item: any) => ({
            ...item,
            type: 'line',
            smooth: true,
            // stack: 'Total',
          })),
        ],
      }
    })
  }

  initYearData(year: any): void {
    this.http.get(`${msUrl.core}/dashboard/${year}/statistics`).subscribe((res) => {
      const { data } = res
      this.yearStatistics = data
    })
  }

  initUnits(year: any): void {
    this.http.get(`${msUrl.core}/dashboard/${year}/unitList`).subscribe((res) => {
      const { data } = res
      this.unitList = [
        ...data.map((val: any) => ({
          name: val.name,
          val: val.id,
        })),
      ]

      const unit = data?.[0]
      if (unit) {
        this.selectedUnit = unit.id
        this.selectedUnitName = unit.name
        this.initUnitYearData(year, unit.id)
        this.initUnitChartData(year, unit.id)
      }
    })
  }

  initUnitYearData(year: any, unit: string): void {
    this.http
      .get(`${msUrl.core}/dashboard/${year}/statistics`, { unitId: unit })
      .subscribe((res) => {
        const { data } = res
        this.unitStatistics = data
      })
  }

  initUnitChartData(year: any, unit: string): void {
    this.http
      .get(`${msUrl.core}/dashboard/${year}/sourceChart`, { unitId: unit })
      .subscribe((res) => {
        const { data } = res
        const { x, y } = data
        const names = [] as any

        y.forEach((item: any) => {
          names.push(item.name)
          // item.data = item.data.map((val: any) => {
          //   return !val ? 0 : val
          // })
        })

        this.option2 = {
          title: {
            text: this.selectedUnitName,
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985',
              },
            },
          },
          legend: {
            show: false,
            data: [...names],
          },
          toolbox: {
            feature: {
              //saveAsImage: {}
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: [...x],
            },
          ],
          yAxis: [
            {
              type: 'value',
            },
          ],
          series: [
            ...y.map((item: any) => ({
              ...item,
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series',
              },
            })),
          ],
        }
      })
  }

  initChart3Data(year: any): void {
    this.http.get(`${msUrl.core}/dashboard/${year}/statistics/unit`).subscribe((res) => {
      const { data } = res
      const { nodes, links, iventoryNodes } = data
        .flatMap((unit: any) =>
          unit.sourceList.flatMap((source: any) =>
            source.inventoryList.map((inventory: any) => ({
              unitName: unit.unitName,
              sourceName: source.sourceName,
              inventoryListName: inventory.inventoryListName,
              emission1: unit.emission,
              emission2: source.emission,
              emission3: inventory.emission,
            })),
          ),
        )
        .reduce(
          (acc: any, current: any) => {
            acc.nodes.add(
              JSON.stringify({
                name: current.unitName,
              }),
            )

            acc.nodes.add(
              JSON.stringify({
                name: current.sourceName,
              }),
            )

            acc.nodes.add(
              JSON.stringify({
                name: current.inventoryListName,
              }),
            )

            acc.iventoryNodes.add(
              JSON.stringify({
                name: current.inventoryListName,
              }),
            )

            acc.links.add(
              JSON.stringify({
                source: current.unitName,
                target: current.sourceName,
                value: current.emission2,
              }),
            )

            acc.links.add(
              JSON.stringify({
                source: current.sourceName,
                target: current.inventoryListName,
                value: current.emission3,
              }),
            )

            return acc
          },
          { nodes: new Set(), links: new Set(), iventoryNodes: new Set() },
        )

      const uniqueNodes = Array.from(nodes).map((node: any) => JSON.parse(node))
      const uniqueLinks = Array.from(links).map((link: any) => JSON.parse(link))
      const iventorys = Array.from(iventoryNodes).map((node: any) => JSON.parse(node))
      const len = iventorys.length
      this.sangjiHeight = `${len * 20 < 200 ? 200 : len * 20}px`

      this.option3 = {
        title: {
          text: this.i18n.fanyi('app.dashboard.sangji.title'),
          show: false,
        },
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          formatter: function (params: any) {
            const { value, name } = params
            return `${name
              .split('>')
              .map((n: any) => n.trim())
              .join(' -- ')} ${round(value, 2)}`
          },
        },
        series: [
          {
            type: 'sankey',
            data: uniqueNodes,
            links: uniqueLinks,
            emphasis: {
              focus: 'adjacency',
            },
            levels: [
              {
                depth: 0,
                itemStyle: {
                  color: '#fbb4ae',
                },
                lineStyle: {
                  color: 'source',
                  opacity: 0.6,
                },
              },
              {
                depth: 1,
                itemStyle: {
                  color: '#b3cde3',
                },
                lineStyle: {
                  color: 'source',
                  opacity: 0.6,
                },
              },
              {
                depth: 2,
                itemStyle: {
                  color: '#ccebc5',
                },
                lineStyle: {
                  color: 'source',
                  opacity: 0.6,
                },
              },
              {
                depth: 3,
                itemStyle: {
                  color: '#decbe4',
                },
                lineStyle: {
                  color: 'source',
                  opacity: 0.6,
                },
              },
            ],
            lineStyle: {
              curveness: 0.5,
            },
          },
        ],
      }

      this.chart3.chart?.resize({ height: len * 20 < 200 ? 200 : len * 20 })
    })
  }

  yearChange(value: string): void {
    this.yearStatistics = {}
    this.unitStatistics = {}
    this.selectedYear = value
    this.selectedUnit = ''
    this.selectedUnitName = ''
    this.option2 = {}
    this.initYearData(value)
    this.initChartData(value)
    this.initUnits(value)
    this.initChart3Data(value)
  }

  unitChange(value: string): void {
    const unit = this.unitList.find((item: any) => item.val === value)
    this.selectedUnitName = unit.name
    this.initUnitYearData(this.selectedYear, value)
    this.initUnitChartData(this.selectedYear, value)
  }

  showFile(name: any): void {
    window.open(`../../../assets/guid/${encodeURI(name)}.pdf`)
  }
}
